module.exports = __webpack_public_path__ + "static/media/camera-black.603125d1.svg";